import React, { useEffect } from 'react';

const Vectary = () => {
  useEffect(() => {
    document.getElementById('vectary_embed').height = window.outerHeight;
    const script = document.createElement('script');
    script.type = 'module';
    script.innerHTML = `
      import { VctrModelApi } from "https://app.vectary.com/studio-lite/scripts/api.js";
  
      const modelApi = new VctrModelApi("vectary_embed");
  
      modelApi.init().then(() => {
        console.log("vectary enabled");

        const selectAndDispatchChange = (option) => {
          if (option) {
            option.selected = true;
            const ev = new Event('change', { bubbles: true });
            option.parentElement.dispatchEvent(ev);
          }
        };

        const changeUiFromModel = (...configs) => {
          console.log("changeUiFromModel",configs);
          const selects = document.querySelectorAll("select");
          selects.forEach(select => {
            configs.forEach(config => {
              const config_active_value = config.active_material
                || config.active_object
                || null;

              if (config_active_value) {
                const optionToSelect = Array.from(select.options)
                  .find(option => option.value === config_active_value);
                selectAndDispatchChange(optionToSelect);
              }
            });
          });
        };

        modelApi.addEventListener(
          "configurator_state_change",
          (configs) => changeUiFromModel(configs)
        );
      });
    `;
    document.body.appendChild(script);
  }, []);
  // https://app.vectary.com/p/2hAlkvJr2tqa1Nz0K3sFx0
  return (
    <React.Fragment>
      <div>
        <div
          dangerouslySetInnerHTML={{
            __html: `
              <iframe 
                  id="vectary_embed" 
                  src="https://app.vectary.com/p/2hAlkvJr2tqa1Nz0K3sFx0" 
                  frameborder="0" 
                  width="100%" 
                  height="850">
              </iframe>
             
            `,
          }}
        ></div>
      </div>
    </React.Fragment>
  );
};

export default Vectary;
